(() => {
  const shouldNormalizeScannerToken = (token) => {
    if (!/[ßẞ]/.test(token || '')) return false;
    const compact = (token || '').replace(/[ßẞ-]/g, '');
    if (!compact) return true;
    if (/\d/.test(token)) return true;
    const lettersOnly = compact.replace(/[^A-Za-z]/g, '');
    return Boolean(lettersOnly) && lettersOnly === lettersOnly.toUpperCase();
  };

  const normalizeScannerQuery = (value) => {
    const source = `${value || ''}`;
    if (!/[ßẞ]/.test(source)) return source;
    return source
      .split(/(\s+)/)
      .map((part) => {
        if (!part || /\s+/.test(part)) return part;
        return shouldNormalizeScannerToken(part) ? part.replace(/[ßẞ]/g, '-') : part;
      })
      .join('');
  };

  const applyToInput = (input) => {
    if (!(input instanceof HTMLInputElement) || input.name !== 'q') return;
    const normalized = normalizeScannerQuery(input.value);
    if (normalized !== input.value) {
      input.value = normalized;
    }
  };

  const init = () => {
    document
      .querySelectorAll('form[action*="/search"] input[name="q"], main-search input[name="q"], search-form input[name="q"]')
      .forEach(applyToInput);
  };

  document.addEventListener(
    'input',
    (event) => {
      applyToInput(event.target);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const input = form.querySelector('input[name="q"]');
      applyToInput(input);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', init);
})();